import { ClaimPagePanelItem } from '../ClaimPagePanel/ClaimPagePanel';
import { userClaimableList } from 'utils/constants/claim.const';

interface IClaimCardView {
  claimList: typeof userClaimableList;
}

export const ClaimCardView = ({ claimList }: IClaimCardView) => {
  return (
    <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 lg:gap-5'>
      {claimList.map((item, index) => (
        <div
          className='flex w-full flex-col gap-5'
          key={item.projectClaimContractAddress + index}
        >
          <ClaimPagePanelItem item={item} />
        </div>
      ))}
    </div>
  );
};
